@if (toastMessage) {
  <sfc-toast disappear-after="2000" [type]=toastMessage.type animate-from="bottom" >{{toastMessage.message}}</sfc-toast>
}
